<template>
  <div class="base-inner">
    <div class="base-head">
      <div class="title">基本信息</div>
    </div>
    <div class="upload">
      <el-upload
        class="avatar-uploader"
        :class="imageUrl || userInfo.avatar ? '' : 'defalut-avatar'"
        :action="serverUpload"
        :show-file-list="false"
        :on-success="handleAvatarSuccess"
        :before-upload="beforeAvatarUpload">
        <div class="upload-photos-box">
          <img class="upload-photos" src="../../assets/images/upload-photos.png" />
        </div>
        <img v-if="imageUrl" :src="imageUrl" class="avatar">
        <img v-else-if="userInfo.avatar" :src="userInfo.avatar" class="avatar">
        <img v-else class="avatar-uploader-icon" src="//kandian-1254383113.file.myqcloud.com/cloud/pc/upload-head-default.png" />
      </el-upload>
    </div>
    <div class="info">
      <div class="label">手机号码</div>
      <div class="phone">{{userInfo.tel}}</div>
    </div>
    <div class="info">
      <div class="label">昵 称</div>
      <div class="phone">
        <el-input v-model="input" placeholder="支持输入1-15个字符"></el-input>
      </div>
    </div>
    <div class="btn" @click="saveInfo">保存</div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';
  import { getUrl } from '../../utils/http';
  import { modifyUserInfo } from '../../server/me';
  import { REG_USER_INPUT } from '../../utils/regs';

  export default {
    name: 'baseInfo',
    computed: {
      ...mapGetters([
        'userInfo'
      ])
    },
    data() {
      return {
        input: '',
        imageUrl: '',
        serverUpload: ''
      };
    },
    mounted() {
      this.serverUpload = getUrl('?r=user/avatar');
      this.imageUrl = this.userInfo.avatar;
    },
    methods: {
      async handleAvatarSuccess(res, file) {
        if (res.code !== 0)  {
          this.$message.error(res.msg);
        } else {
          this.imageUrl = res.data.src;
           const obj = {
            avatar: this.imageUrl
          };
          const { code = 1, msg = '' } = await modifyUserInfo(obj);
          if (code === 0) {
            this.$store.dispatch('user/getInfo')
          } else {
            this.$message.error(msg);
          }
        }
      },
      beforeAvatarUpload(file) {
  
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }

        console.log('isLt2M:', isLt2M);
        return isLt2M;
      },
      async saveInfo() {
        if (!this.input) {
          this.$message.error('请输入昵称');
        } else if (!REG_USER_INPUT.test(this.input)) {
          this.$message.error('请输入1-15个字符');
        } else {
          const obj = {
            name: this.input,
            avatar: this.imageUrl
          };
          const { code = 1, msg = '' } = await modifyUserInfo(obj);
          if (code === 0) {
            this.$store.dispatch('user/getInfo');
          } else {
            this.$message.error(msg);
          }
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '../../assets/css/style.scss';

  .base-inner {
    padding-bottom: 320px;
  }

  .base-head {
    height: 67px;
    margin-bottom: 29px;
    border-bottom: 1px solid #F0F0F0;

    .title {
      height: 67px;
      margin-left: 33px;
      padding-left: 9px;
      // border-left: 4px solid $color-primary;

      font-size: 20px;
      color: #333;
      line-height: 67px;
      position: relative;

      &::before {
        content: '';
        display: block;

        width: 4px;
        height: 20px;

        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        background-color: $color-primary;
      }
    }
  }

  .avatar-uploader {
    width: 88px;
    height: 88px;
    margin: 29px auto 57px;
    border-radius: 50%;

    &.defalut-avatar {
      background-color: #999;
    }

    .avatar-uploader-icon {
      width: 36px;
      height: 31px;
      display: block;
      margin: 39px auto 0;
    }
  }

  .info {
    height: 40px;
    padding: 0 45px;
    margin-bottom: 36px;

    font-size: 20px;
    color: #333;
    @include flex-vertical-center();

    .label {
      width: 80px;
      margin-right: 20px;
      margin-top: 29px;
      text-align: justify;
      &:after {
        content: " ";
        display: inline-block;
        width: 100%;
      }
    }
  }

  .btn {
    margin-left: 45px;
    width: 90px;
    height: 40px;

    font-size: 15px;
    color: #fff;
    text-align: center;
    line-height: 40px;
    background-color: $color-primary;
    border-radius: 5px;
    cursor: pointer;
  }
</style>

<style lang="scss">
  @import '../../assets/css/style.scss';
    .upload {
      position: relative;

      .upload-photos-box {
        width: 88px;
        height: 88px;
        border-radius: 50%;
        background: rgba(0, 0, 0, .27);


        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
        cursor: pointer;

        .upload-photos {
          width: 29px;
          height: 25px;

          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }
      
      .el-upload {
        width: 100%;
        height: 100%;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }

      .el-upload:hover {
        border-color: #409EFF;
      }
    }
  
  .avatar {
    width: 88px;
    height: 88px!important;
    display: block;

    border-radius: 50%;
  }
 
</style>



// WEBPACK FOOTER //
// src/views/personal/baseInfo.vue